var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noAccess_box"},[_vm._v("\n\n    抱歉  您无权访问此页面！\n")])}
var staticRenderFns = []

export { render, staticRenderFns }